/**
 * Estado y ciudad de residencia del candidato.
 *
 * El back sigue guardando un solo texto (`residenceCity`), asi que la
 * seleccion se junta con el mismo formato que el campo ya sugeria:
 * «Monterrey, Nuevo León».
 */
export interface EstadoDeMexico {
  id: number
  code: string
  name: string
}

export interface CiudadDeMexico {
  id: number
  code: string
  name: string
}

export const textoDeResidencia = (ciudad: string, estado: string): string =>
  `${ciudad.trim()}, ${estado.trim()}`

export const errorDeResidencia = (
  estadoId: string,
  ciudadId: string,
): string | undefined => {
  if (!estadoId) return 'Selecciona el estado de residencia'
  if (!ciudadId) return 'Selecciona la ciudad de residencia'
  return undefined
}

/** Sin acentos, mayúsculas ni espacios de más: para comparar nombres. */
export const normalizarNombre = (texto: string): string =>
  texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()

/**
 * Parte «Monterrey, Nuevo León» en ciudad y estado. Corta en la ultima coma,
 * porque el estado es lo que va al final. Null si el texto no tiene ese
 * formato (un valor capturado a mano antes del selector).
 */
export const separarResidencia = (
  texto: string,
): { ciudad: string; estado: string } | null => {
  const coma = texto.lastIndexOf(',')
  if (coma <= 0) return null
  const ciudad = texto.slice(0, coma).trim()
  const estado = texto.slice(coma + 1).trim()
  return ciudad && estado ? { ciudad, estado } : null
}

export const buscarPorNombre = <T extends { name: string }>(
  lista: readonly T[],
  nombre: string,
): T | undefined => {
  const buscado = normalizarNombre(nombre)
  return lista.find((item) => normalizarNombre(item.name) === buscado)
}
